// Tabs.tsx
import React, { useEffect, useState } from "react";
import EventLogTable from "../../common/Searchbar/EventLogTable";
import dayjs, { Dayjs } from 'dayjs';
import FTPFormTable from "../../common/Searchbar/FTPFormTable";

type SetTabPageFunction = React.Dispatch<React.SetStateAction<string>>

interface TabsProps {
    ftpData?: any[];
    setTabDivHeight: SetTabPageFunction;
    addedRows: any[];
    setAddedRows: React.Dispatch<React.SetStateAction<any[]>>;
    isToggle?: boolean;
    selectedOption: string;
    setSelectedOption: React.Dispatch<React.SetStateAction<string>>
    selectedRange: {
        start: Dayjs | null;
        end: Dayjs | null;
    };
    setSelectedRange: React.Dispatch<React.SetStateAction<{
        start: Dayjs | null;
        end: Dayjs | null;
    }>>;
    setClickApply: React.Dispatch<React.SetStateAction<boolean>>;
    showFTPDataMessage: boolean;
    onHandleRefresh: () => Promise<void>;
    assetId: string;
}

const FTPForm: React.FC<TabsProps> = ({ setTabDivHeight, ftpData, assetId, addedRows, setAddedRows, selectedOption, setSelectedOption, selectedRange, setSelectedRange, setClickApply, showFTPDataMessage,onHandleRefresh }) => {

    return (
        <div className="flex flex-col w-full">
            <div className="text-Darkmode-700 p-3">
                <FTPFormTable tableData={ftpData} assetId = {assetId} setTabDivHeight={setTabDivHeight} onHandleRefresh = {onHandleRefresh} addedRows={addedRows} setAddedRows={setAddedRows} isToggle selectedOption={selectedOption} setSelectedOption={setSelectedOption} selectedRange={selectedRange} setSelectedRange={setSelectedRange} setClickApply={setClickApply} showFTPDataMessage={showFTPDataMessage} />
            </div>
        </div>
    );
};

export default FTPForm;
